import * as React from 'react';
import {useSelector} from 'react-redux';

import {Field} from 'redux-form';

import {Assignables} from 'nutshell-core/assignables';

import {FormField} from 'shells/form/form-field';

import {AssigneeSelect} from './assignee-select';
import {AUTO_ASSIGN_OPTION, UNASSIGNED_OPTION} from './consts';

type Props = {
    fieldKey: string;
    isRequired: boolean;
    validate: (...args: any) => any;
    isDisabled: boolean;
    // These are mutually exclusive — showAutoAssign takes precedence if both are true.
    // Leads use showAutoAssign ("Follow pipeline assignment rules"), while
    // contacts/accounts use showUnassigned ("Unassigned").
    showAutoAssign?: boolean;
    showUnassigned?: boolean;
};

export function AssigneeSelectField(props: Props) {
    const assignables = useSelector(Assignables.getAllEnabled);

    let options;
    if (props.showAutoAssign) {
        // @ts-expect-error
        options = [AUTO_ASSIGN_OPTION, ...assignables];
    } else if (props.showUnassigned) {
        // @ts-expect-error
        options = [UNASSIGNED_OPTION, ...assignables];
    } else {
        options = assignables;
    }

    return (
        <FormField
            key={props.fieldKey}
            innerId={props.fieldKey}
            isRequired={props.isRequired}
            label='Assignee'
        >
            <Field
                name={props.fieldKey}
                component={AssigneeSelect}
                options={options}
                placeholder='Select an assignee'
                {...props}
            />
        </FormField>
    );
}
